// extracted by mini-css-extract-plugin
export default {"card":"a2-z"};